import { render, staticRenderFns } from "./CheckInput.vue?vue&type=template&id=23b6e5ae"
import script from "./CheckInput.vue?vue&type=script&lang=js"
export * from "./CheckInput.vue?vue&type=script&lang=js"
import style0 from "./CheckInput.vue?vue&type=style&index=0&id=23b6e5ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports